import Tokenizer from 'sentence-tokenizer'
const tk = new Tokenizer('Chuck')

export const countSentences = (text: string) => {
  tk.setEntry(text)
  return tk.getSentences().length
}
